import Component from "./ProviderClinicsProgramEnrollmentTable";

export default Component;
